module.exports = __webpack_public_path__ + "static/media/4fe96905-e2ad-45bc-8f77-69e3e48bbacf_1.48dfc38079cd03116f9ff7335c6b12cd.5abcab9d.jpeg";